import { Box } from '@mui/material'
import { useId, forwardRef } from 'react'
import Field from './Field'

export const FieldWrapper = forwardRef(({ field, ...props }, ref) => {
  const id = useId()
  const width = field?.sizeDivided ? `calc(${100 / field.sizeDivided}% - ${(field.sizeDivided - 1) * 10}px)` : '100%'

  return (
    <Box
      sx={{
        marginRight: '10px',
        width
      }}
    >
      <Field id={id} {...props} key={props.key ?? field?.name ?? id} field={field} ref={ref} />
    </Box>
  )
})
